import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  Grid,
  TextField,
  Container,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { UrlApi } from "../../../services/apirest";
import { logEventos } from "../../../services/services";

const MotivosDesplegablesForm = ({
  isEditMode,
  rowInfo,
  handleOpenCloseModalForm,
  getMotivos,
  mostrarAlertaTemporal,
}) => {
  const [data, setData] = useState({
    id: isEditMode ? rowInfo.id : undefined,
    valor: isEditMode ? rowInfo.valor : "",
    user: isEditMode ? rowInfo.user : localStorage.getItem("user"),
    activa: isEditMode ? rowInfo.activa : 1,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    logEventos(
      isEditMode ? "Editar motivo desplegable" : "Agregar motivo desplegable",
      "Motivos desplegables",
      isEditMode
        ? "Editar un motivo desplegable"
        : "Crear un motivo desplegable",
      localStorage.getItem("user")
    );

    let isValidForm = true;

    if (!data.valor || data.valor?.trim() === "") {
      mostrarAlertaTemporal(
        "Por favor, complete todos los campos requeridos.",
        "error"
      );
      isValidForm = false;
    }

    if (isValidForm) {
      const newMotivo = {
        valor: data.valor,
        user: data.user,
        activa: data.activa,
      };

      const url = isEditMode
        ? `${UrlApi}/SP_motivos_desplegables/${rowInfo.id}`
        : `${UrlApi}/SP_motivos_desplegables`;
      const method = isEditMode ? "PUT" : "POST";

      try {
        const response = await fetch(url, {
          method,
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(newMotivo),
        });

        if (!response.ok) {
          const errorData = await response.json();
          mostrarAlertaTemporal(
            `Error al ${isEditMode ? "actualizar" : "agregar"} el motivo: ${
              errorData.message || "Desconocido"
            }`,
            "error"
          );
          return;
        }

        mostrarAlertaTemporal(
          isEditMode
            ? "Actualización realizada correctamente"
            : "Motivo agregado con éxito",
          "success"
        );
        getMotivos();
        handleOpenCloseModalForm();
      } catch (error) {
        mostrarAlertaTemporal("Hubo un problema con la solicitud.", "error");
      }

      handleOpenCloseModalForm();
    }
  };

  return (
    <Dialog
      open={true}
      onClose={handleOpenCloseModalForm}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="lg"
      fullWidth
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#1F618D",
          width: "100%",
          marginBottom: 4,
        }}
      >
        <DialogTitle>
          <Box component="div">
            <Typography
              variant="h6"
              align="center"
              color="#ffffff"
              sx={{ fontWeight: "bold" }}
            >
              {isEditMode ? "Editar motivo" : "Agregar nuevo motivo"}
            </Typography>
          </Box>
        </DialogTitle>
      </Box>
      <Container>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <TextField
              sx={{ overflow: "hidden" }}
              fullWidth
              label="Motivo"
              name="valor"
              value={data.valor}
              inputProps={{ maxLength: 300 }}
              helperText={`${data.valor?.length ?? 0}/300 caracteres`}
              onChange={handleChange}
              variant="outlined"
              multiline
              rows={3}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: 3,
            }}
          >
            <Button
              variant="contained"
              color="error"
              onClick={handleOpenCloseModalForm}
            >
              Volver
            </Button>
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              {isEditMode ? "Guardar Cambios" : "Agregar motivo"}
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Dialog>
  );
};

//comentario para subir hacer merge

export default MotivosDesplegablesForm;
